import React from 'react';

const SvgSafety = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M18.192 3C18.4 4.233 19.55 5.212 21 5.389v6.201c0 4.813-3.61 8.981-9 10.41-5.347-1.417-9-5.623-9-10.41v-6.2a3.567 3.567 0 001.802-.743C5.334 4.22 5.7 3.644 5.808 3h12.384zm-3.52 5.408l-3.603 3.564-1.74-1.721a.455.455 0 00-.64 0l-1.321 1.307a.443.443 0 000 .632l1.74 1.722 1.641 1.624a.455.455 0 00.64 0l1.64-1.624 3.604-3.564a.444.444 0 000-.631L15.31 8.408a.455.455 0 00-.638 0z"
}));

export default SvgSafety;